import { gql } from "@apollo/client";
import { TOPIC_ADDITIONAL_FIELDS_FRAGMENT } from "../fragments/TopicFragments";

const GET_CLASS_DETAILS = gql`
  query ClassDetails($id: ID!) {
    classDetails(id: $id) {
      currentClass {
        id
        date
        time
        startTime
        endHour24hr
        classType
        classSize
        seatsRemaining
        category
        annotatedLink
        bookedAt
        rated
        rateable
        overlapped
        credits
        wherebyLink
        language {
          id
          englishName
          realName
          bannerBackground
        }
        teacher {
          id
          avatar
          givenName
          familyName
        }
        topic {
          ...TopicAdditionalFields
          materials {
            id
            learningMaterialLink
            audioLink
            city {
              id
              name
            }
          }
        }
        city {
          id
          name
        }
        level {
          title
        }
        chapter {
          name
        }
        participants {
          id
          name
          avatar
          forumProfile
        }
        course {
          id
          title
          levelId
          courseType
        }
      }
      appointment {
        bookedAt
        oooNotes
        status
      }
      myTopic {
        skipped
        studied
        studiedCount
      }
      myRating {
        id
        teacher {
          rating
          comment
        }
        material {
          rating
          comment
        }
      }
    }
  }
  ${TOPIC_ADDITIONAL_FIELDS_FRAGMENT}
`;

export default GET_CLASS_DETAILS;
